<nav class="navbar navbar-expand-lg sticky">
    <!-- <button class="navbar-toggler" type="button" data-toggle="collapse" 
        data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
    <p class="p-app-name my-auto">GRT Branding Monitoring {{message}}</p> -->
    <div class="navbar-wrapper d-flex my-auto">
        <div class="navbar-toggle">
          <button type="button" class="navbar-toggler" (click)="sidebarToggle()">
            <span class="navbar-toggler-bar bar1"></span>
            <span class="navbar-toggler-bar bar2"></span>
            <span class="navbar-toggler-bar bar3"></span>
          </button>
        </div>
        <a class="p-app-name my-auto" href="javascript:void(0)">GRT Branding Monitoring {{message}}</a>
      </div>
    <!-- profile  -->
    <button class="navbar-toggler ml-auto mr-2" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <i class="fa fa-user fa-sm text-white"></i>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav ml-auto align-items-center">
        <li class="nav-item active">
            <div class="d-flex align-items-center"  id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <a class="a-profile pointer">
                    <img  onerror="this.src='/assets/images/faces/dummy.png'"  src="https://brandmonitoringapp.grtjewels.com/api/uploads/{{userImage}}" class="img-thumbnail avatar" alt="">
                </a>
                <a class="a-profile pointer">
                    <div class="ml-3 mr-3 emp-name-parent " >
                        <p class="m-0 p-0 text-white">{{userName}}</p>
                        <!-- <p class="m-0 p-0 text-white"><small>{{userRole}}</small></p> -->
                    </div>
                </a>
            </div>

            <div class="dropdown-menu mp-0 dropdown-menu-right message-menu" aria-labelledby="dropdownMenuButton">
                <div class="dropdown-item min-height-item"  [routerLink]="['profile']" >
                  <span><i class="p-1 fa fa-user-o fa-lg navbar-icon"></i> My Profile</span>
                </div>

                <div class="dropdown-item min-height-item mt-2"  [routerLink]="['password']" >
                    <span><i class="p-1 fa fa-key fa-lg navbar-icon"></i> Change Password</span>
                  </div>
        
            </div>
            
        </li>
      </ul>  
    </div>  
</nav>
   
<ng-template #mymodal let-modal>
    <i class="fa fa-md fa-times-circle m-1 txt-sl-blue text-right close" (click)="modal.dismiss('Cross click')"></i>
    <h2 class="txt-l-red p-0 m-1 text-center">What you like to find ?</h2>    
    <div class="modal-body w-100 mp-0 ">
      
        <div class="sl-search ml-5 mt-2 mr-5">
            <div class="input-group search-group mp-0">
                <span class="input-group-btn">
                    <button class="btn btn-search" type="button"><i class="fa fa-search txt-l-red fa-sm"></i></button>
                </span>
                <input type="text" class="form-control sl-search" placeholder="Search...">                                   
            </div>
            <div class="d-flex row sl-topics">
                <p class="txt-topics">Keyword : </p>
                <div class="row m-0 p-0">
                    <div class="m-0 p-1" *ngFor="let data of dataSearch">
                        <div class="sl-group-invite vertical-center">
                            <tr>
                                <td class="align-items-center"> 
                                    <a href="" class="sl-search-name">{{data.name}}</a>
                                </td>
                            </tr>
                        </div>
                    </div>
                </div>
            </div>
            <div class="sl-search-data">
                <div class="row list w-100 mp-0" *ngFor="let data of dataSearchInfo">
                    <div class="media m-1 align-items-center">
                        <div class="sl-search-avatar rounded-circle-grey m-2 align-items-center">
                            <span class="mt-1 fa fa-link fa-lg light_grey my-icon" ></span>
                        </div>
                        <div class="media-body pointer">
                          <p class="m-0 p-0 txt-black font16">{{data.title}}</p>
                          <a class="m-0 p-0 font15 txt-l-red">{{data.sub_title_link}}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>      
    </div>
</ng-template>